export default __webpack_public_path__ + "static/kynnet2-41f8374648871f996ecdf1134fe7dded.jpeg";